module.exports = __webpack_public_path__ + "static/img/image022.3ac1976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image022.png
// module id = r1nS
// module chunks = 1